<script>
import Swal from "sweetalert2";
import {cloneDeep} from "lodash";
export default {
    name: "ImportApi",
    data() {
        return {
            tableData: [],
            filter: "",
            loading: false,
            selectedTarget: {apis: []},
        };
    },
    computed: {
        selectedApi() {
            let data = [];
            this.selectedTarget.apis.forEach((api) => api.toggleSelected && data.push(api))
            return data;
        },
        filteredAPIs() {
            let data = this.tableData;
            if (this.filter.trim() != "" && this.filter) {
                data = data.filter((item) => {
                    return item.searchApi
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            return data;
        },
    },
    methods: {
        getData() {
            this.loading = true;
            this.tableData = [];
            this.$store
                .dispatch(
                    "preplanningtarget/GetMyPrePlanning",
                    this.$store.state.data.cycle
                )
                .then(async (res) => {
                    for await (const item of res.data) {
                        item.checkAllWork = false;
                        item.apis = [];
                        item.searchApi = "";
                        await this.getApis(item);
                        if (item.apis.length > 0) {
                            this.tableData.push(item);
                        }
                    }
                    if(this.tableData.length > 0){
                        this.selectTarget(this.tableData[0])
                    }
                    this.loading = false;
                })
                .catch((err) => {
                    this.loading = false;
                    this.showToast(
                        "Something went wrong - getting preplanning",
                        "error"
                    );
                });
        },
        async getApis(item) {
            await this.$store
                .dispatch("preplanningapi/GetPrePlanningApis", item.id)
                .then((res) => {
                    item.searchApi =
                        res.data.map((api) => api.name).join(" ") +
                        " " +
                        item.targetTemplate.description;
                    res.data.map((api) => {
                        api.toggleSelected = false;
                    });
                    item.apis = res.data;
                })
                .catch((err) => {
                    this.showToast(
                        "Something went wrong - getting apis",
                        "error"
                    );
                });
        },
        checkEntireTarget() {
            this.selectedTarget.apis.forEach((item) => {
                item.toggleSelected = this.selectedTarget.checkAllWork;
            });
        },
        checkApi() {
            let count = 0;
            this.selectedTarget.apis.forEach((item) => {
                item.toggleSelected && count++;
            });
            this.selectedTarget.checkAllWork = count == this.selectedTarget.apis.length ? true : false;
        },
        dropData() {
            Swal.fire({
                text: "Are you sure you want to import selected apis?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#9b2ddb",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, import it!",
            }).then((result) => {
                if (result.value) {
                    this.$emit("dropData", this.selectedApi);
                }
            });
        },
        selectTarget(x) {
            this.selectedTarget = cloneDeep(x);
        },
    },
};
</script>
<template>
    <b-modal
        id="import-api-modal"
        title="Import API List"
        size="xl"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
    >
        <div class="row mt-1" v-if="filteredAPIs.length > 0 && !loading">
            <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter">
                    <label class="d-inline-flex align-items-center">
                        Search:
                        <b-form-input
                            autocomplete="off"
                            v-model="filter"
                            type="search"
                            placeholder="Search..."
                            class="form-control form-control-sm ms-2"
                        ></b-form-input>
                    </label>
                </div>
            </div>
        </div>
        <div
            class="
                d-flex
                justify-content-center
                align-items-center
            "
            v-if="loading"
        >
            <div class="preloader-component me-2">
                <div class="status">
                    <div
                        class="
                            spinner-chase
                            w-20px
                            h-20px
                        "
                    >
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                    </div>
                </div>
            </div>
            <strong>Loading...</strong>
        </div>
        <div
            class="text-muted text-center py-2 px-3"
            v-if="filteredAPIs.length == 0 && !loading"
        >
            <i class="dripicons-warning me-1"></i>No data
            found
        </div>
        <div class="row" v-if="filteredAPIs.length > 0 && !loading">
            <div class="col-md-4">
                <div class="d-flex flex-column">
                    <div class="border mb-2 cursor-pointer" @click="selectTarget(x)" v-for="x in filteredAPIs" :key="x.id" :class="{'bg-purple': x.id == selectedTarget.id}">
                        <div class="card-body">
                            <div class="d-flex align-items-center">
                                <div class="mb-2">
                                    <label
                                        class="form-check-label"
                                        :class="{'text-white': x.id == selectedTarget.id}"
                                    >
                                        {{ x.targetTemplate.description }}
                                    </label>
                                    <div>
                                        <span ><small class="text-muted">KPI:</small>&nbsp;<span class="text-info" :class="{'text-white': x.id == selectedTarget.id}">{{x.targetTemplate.indicatorItem.indicatorItemName}}</span></span>
                                    </div>
                                    <div>
                                        <span><small class="text-muted">SDA/Program/KRA:</small>&nbsp;<span class="text-warning" :class="{'text-white': x.id == selectedTarget.id}">{{x.targetTemplate.indicatorItem.indicator.prexc.prexcName}}</span></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-8">
                <table class="table table-bordered" >
                    <thead>
                        <tr>
                            <th style="width:40px;" class="align-center">
                                <div
                                    class="
                                        form-check
                                        form-checkbox-outline
                                        form-check-success
                                        mb-0
                                    "
                                >
                                    <input
                                        type="checkbox"
                                        :id="`targetCheckBox`"
                                        class="
                                            form-check-input
                                        "
                                        v-model="
                                            selectedTarget.checkAllWork
                                        "
                                        @change="checkEntireTarget"
                                    />
                                </div>
                            </th>
                            <th>API Name</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="selectedTarget.apis.length == 0">
                            <td class="text-center" colspan="2">No data found</td>
                        </tr>
                        <template v-if="selectedTarget.apis.length > 0">
                            <tr v-for="x in selectedTarget.apis" :key="x.id">
                                <td>
                                    <div
                                        class="
                                            form-check
                                            form-checkbox-outline
                                            form-check-success
                                            mb-0
                                        "
                                    >
                                        <input
                                            type="checkbox"
                                            :id="`customCheckcolor${x.id}`"
                                            class="
                                                form-check-input
                                            "
                                            v-model="
                                                x.toggleSelected
                                            "
                                            @change="checkApi"
                                        />
                                    </div>
                                </td>
                                <td>
                                    <b>{{x.name}}</b>
                                    <div>
                                        <small>{{x.description}}</small>
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
        <hr v-if="selectedApi.length > 0"/>
        <div class="float-end" v-if="selectedApi.length > 0">
            <button
                type="button"
                class="btn btn-purple d-flex align-items-center"
                @click="dropData"
            >
                <i class="bx bx-download me-1"></i>Import
                {{ selectedApi.length }} selected
            </button>
        </div>
    </b-modal>
</template>